export watchCampaigns from './campaigns.saga';
export watchLogs from './logs.saga';
export watchApps from './apps.saga';
export watchImpressions from './impressions.saga';
export watchAuth from './auth.saga';
export watchLeads from './leads.saga';
export watchClicks from './clicks.saga';
export watchAccounts from './accounts.saga';
export watchAccountManagers from './accountManagers.saga';
export watchUsers from './users.saga';
export watchPostbacks from './postbacks.saga';
export watchProfile from './profile.saga';
export watchFormSubmitSaga from './onSubmitActions.saga';
export watchDashboard from './dashboard.saga';
export watchPlayables from './playables.saga';
export watchRequestLogs from './requestLogs.saga';
export watchCampaignLogs from './campaignLogs.saga';
export watchOffers from './offers.saga';
export watchPlacements from './placements.saga';
export watchFillRate from './fillRate.saga';
export watchApiStatuses from './apiStatuses.saga';
export watchOfferWallLogs from './offerWallLogs.saga';
export watchPayments from './payments.saga';
export watchAdjustments from './adjustments.saga';
export watchDownloadCreativeErrorLogs from './downloadCreativeErrorLogs.saga';
export testDevices from './testDevices.saga.js';
export userInterests from './userInterests.saga.js';
export notifications from './notifications.saga.js';
export messageLogs from './messageLogs.saga.js';
export impressionsReports from './impressionsReports.saga.js';
export globalSettings from './globalSettings.saga.js';



/** WEBPACK FOOTER **
 ** ./js/redux/saga/index.js
 **/